export const contentTableConfig = {
  title: '新资源数据统计查询',
  propList: [
    { prop: 'usedBy', label: '组员', minWidth: '120' },
    { prop: 'accountId', label: '账号ID', minWidth: '120' },
    {
      prop: 'corpName',
      label: '企微主体',
      minWidth: '150'
    },
    {
      prop: 'beginDate',
      label: '开始时间',
      minWidth: '150'
    },
    {
      prop: 'endDate',
      label: '结束时间',
      minWidth: '150'
    },
    {
      prop: 'totalCount',
      label: '总数',
      minWidth: '80'
    },
    {
      prop: 'replyOneCount',
      label: '回复大于1条客户数',
      minWidth: '80',
      sortable: true
    },
    {
      prop: 'replyOnePercent',
      label: '回复大于1条客户占比',
      minWidth: '80',
      sortable: true
    },
    {
      prop: 'replyThreeCount',
      label: '回复大于3条客户数',
      minWidth: '80',
      sortable: true
    },
    {
      prop: 'replyThreePercent',
      label: '回复大于3条客户占比',
      minWidth: '80',
      sortable: true
    },
    {
      prop: 'replyFiveCount',
      label: '回复大于5条客户数',
      minWidth: '80',
      sortable: true
    },
    {
      prop: 'replyFivePercent',
      label: '回复大于5条客户占比',
      minWidth: '80',
      sortable: true
    },
    {
      prop: 'replyTenCount',
      label: '回复大于10条客户数',
      minWidth: '80',
      sortable: true
    },
    {
      prop: 'replyTenPercent',
      label: '回复大于10条客户占比',
      minWidth: '80',
      sortable: true
    },
    {
      prop: 'replyAfterThreeDaysCount',
      label: '3天后回复客户数',
      minWidth: '80',
      sortable: true
    },
    {
      prop: 'replyAfterThreeDaysPercent',
      label: '3天后回复客户占比',
      minWidth: '80',
      sortable: true
    },
    {
      prop: 'replyAfterSevenDaysCount',
      label: '7天后回复客户数',
      minWidth: '80',
      sortable: true
    },
    {
      prop: 'replyAfterSevenDaysPercent',
      label: '7天后回复客户占比',
      minWidth: '80',
      sortable: true
    },
    {
      prop: 'dayDeleteCount',
      label: '当天删除客户数',
      minWidth: '80',
      sortable: true
    },
    {
      prop: 'dayDeletePercent',
      label: '当天删除客户占比',
      minWidth: '80',
      sortable: true
    },
    {
      prop: 'threeDayDeleteCount',
      label: '三天内删除客户数',
      minWidth: '80',
      sortable: true
    },
    {
      prop: 'threeDayDeletePercent',
      label: '三天内删除客户占比',
      minWidth: '80',
      sortable: true
    },
    {
      prop: 'weekDeleteCount',
      label: '一周内删除客户数',
      minWidth: '80',
      sortable: true
    },
    {
      prop: 'weekDeletePercent',
      label: '一周内删除客户占比',
      minWidth: '80',
      sortable: true
    },
    {
      prop: 'withBeforeDeadLine',
      label: '截止指定日期删除客户数',
      minWidth: '80',
      sortable: true
    },
    // {
    //   prop: 'funds0wTo5wCount',
    //   label: '资金量<5w',
    //   minWidth: '80',
    //   sortable: true
    // },
    // {
    //   prop: 'funds0wTo5wPercent',
    //   label: '资金量<5w占比',
    //   minWidth: '80',
    //   sortable: true
    // },
    // {
    //   prop: 'funds5wTo10wCount',
    //   label: '资金量5w-10w',
    //   minWidth: '80',
    //   sortable: true
    // },
    // {
    //   prop: 'funds5wTo10wPercent',
    //   label: '资金量5w-10w占比',
    //   minWidth: '80',
    //   sortable: true
    // },
    // {
    //   prop: 'funds10wCount',
    //   label: '资金量>10w',
    //   minWidth: '80',
    //   sortable: true
    // },
    // {
    //   prop: 'funds10wPercent',
    //   label: '资金量>10w占比',
    //   minWidth: '80',
    //   sortable: true
    // }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
